<app-print-report-template-list></app-print-report-template-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreatePrintTemplateModal()">
    Create Report Template
  </lib-button-primary>
</lib-button-input-portal>
